export const handleError = (error: any) => {
  if (error.data.status === 403 || error.data.status === 401) {
    return { name: 'login' }
  } else return { name: 'notFound' }
}
